export default __webpack_public_path__ + "static/media/Custom-HUD-Targeting (Reticle, 1L).ba7b8ab6.jpg";